
import React, { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { timesheetreportService } from '../services/timesheetreportsService';
import { timesheetService } from '../services/timesheetService';
import { timesheetuserService } from '../services/timesheetUserservice';
import { formatterhelper } from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import { loader } from '../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer, FaCheck, FaEdit, FaRecycle, FaSearch, FaTrash } from "react-icons/fa";
import Smallloader from '../compnents/loader';
import { Mandate } from '../compnents/formcomp';
import { Message } from 'primereact/message';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { calculatepercent } from '../helpers/calculatepercent';


const Timesheetadmin = () => {
   const toast = useRef(null);
   const [formData, setFormData] = useState({
      fromdate: '',
      employee: '',
   });
   const [datacomp, setDatacomp] = useState([]);
   const [rdsdatacomp, setrdsDatacomp] = useState([]);
   const [dataavail, setDatastate] = useState(false);
   const [clientscomp, setClientscomp] = useState([]);
   // const [clientscomp,setClientscomp1] = useState([]); 
   const [subclientscomp, setsubClientscomp] = useState([]);
   const [subclients, setsubClients] = useState([]);
   const [subtaskscomp, settaskscomp] = useState([]);
   const [subclientLoader, setSubclientloader] = useState(<></>);
   const [empcomp, setempcomp] = useState([]);
   const [totalpages, setPages] = useState(0);
   const [filterobj, setfilterobj] = useState({});

   const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
   const [isloaded, setloading] = useState(true);
   const [first, setFirst] = useState(0);
   const [rows, setRows] = useState(15);
   const [addtimesheettoggle, settoggle] = useState(false);
   const [editobj, seteditobj] = useState(null);
   const [toggleaddform, settoggleaddform] = useState(false);
   const [remainhrsloaded, setremainhrsloaded] = useState(true);
   const [remainloaded, setreminloader] = useState(true);
   const [errors, setErrors] = useState({});
   const [objdata_, setObjdata_] = useState({});
   const [minutestcount,setminutescount] = useState({minutes:0,count:0});
   const [tempdata, setTempdata] = useState([]);
   const [percentage, setPercentage] = useState('');
   const [percentval, setPercentval] = useState('');
   const [selecteddate, setSelecteddate] = useState('');

   const [formData2, setForm2Data] = useState({
      selectedclient: '',
      selectedsubclient: '',
      task: '',
      minutes: '',
      billedminutes: '',
      budgethours: '',
      remainingbudgethours: '',
      count: '',
      fillingfor: '',
      remarks: ''
   });

   const [tmaddformData, tmaddsetFormData] = useState({
      client: '',
      subclient: '',
      subclientid: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      WorkFrom: '',
      budget_hours: '',
      date: '0',
      querycount: '',
      remaining_hrs: '',
   });

   const [editformData, seteditFormData] = useState({
      client: '',
      subclient: '',
      subclientid: '',
      BilledMinutes: '',
      Count: '',
      Minutes: '',
      Remarks: '',
      Task: '',
      WorkFrom: '',
      taskid: '',
      budget_hours: 0,
      date: 0,
      fillingfor: 0,
      querycount: '',
      remaining_hrs: 0
   });
   const [monthsdata, setMonthsdata] = useState([]);
   const [filteredobj, setfilterObject] = useState({});

   useEffect(() => {
      getuserslist();
      _getallclient();
      _gettasks();

      getteammembers();
   }, []);



   useEffect(()=>{
      counterfunction();
   },[tempdata]);

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));

      if (name == 'fromdate' && (formData.userid != '')) {
           //formData.userid = '';
           let objdata = {
            'date': formatterhelper.dateformatter({ date: value }),
            'userid': formData.employee
            };
            setObjdata_(objdata);
            selusrtms(objdata);

            setfilterObject((prevData) =>{
                  return {
                     ...prevData,
                     'date':formatterhelper.dateformatter({date:value})
                  }
            });
      }

      if (name == 'employee') {
         let objdata = {
            'date': formatterhelper.dateformatter({ date: formData.fromdate }),
            'userid': value
         };
         setObjdata_(objdata);
         selusrtms(objdata);
         setfilterObject((prevData) =>{
                return {
                    ...prevData,
                'userid':value,
                }
            }); 
      }

      if (name == 'client') {
         //   setSelectedCateg(value);
          getPercentage(value);
      }

      if(name == 'BilledMinutes'){
         console.log(value);
         let percent = calculatepercent(value,percentage);
         setPercentval(percent);
    }
   };


   const getPercentage = (client,{value} = {}) => {
      timesheetService.getparticularpercentage(client).then((response) => {
         if (response.status == 200) {
            // if(value != undefined){
               let percent = calculatepercent(value,response.data.data.percentage);
               setPercentval(percent);
               setPercentage(response.data.data.percentage);    
            // }
         } else {
            setPercentage('');
         }
      }).catch((error) => {
         setPercentage();
      })
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      let reportobj = {
         'frmdt': formatterhelper.dateformatter({ date: formData.fromdate }),
      };

      // Now you can perform any further actions with the form data
   };



   const tmaddChange = (e) => {
      const { name, value } = e.target;
      tmaddsetFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
      let selected_client = '';
      if (name == 'client') {
         //   setSelectedCateg(value);
         selected_client = value;
         getallsubclients({ client: selected_client });
         getPercentage(value);
      }

      if (name == 'subclient') {
         // formData.client;
         // get remainign hours
         let subclientobj = subclients[e.target.selectedIndex - 1];
         tmaddsetFormData((prevData) => ({
            ...prevData,
            subclientid:subclientobj.id 
         }));

         const filling_date = formatterhelper.dateformatter({ date: formData.fromdate });

         getremaining_hrs({ clientid: tmaddformData.client, subclientid: value, ftype: 'add',date:filling_date });
      }

      if(name == 'BilledMinutes'){
         // console.log(value);
         let percent = calculatepercent(value,percentage);
         setPercentval(percent);
      }
   };

   const getremaining_hrs = ({ clientid, subclientid, ftype,date }) => {
      setremainhrsloaded(false);
      setreminloader(false);
      if (ftype == 'add') {
         tmaddsetFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      } else {
         seteditFormData((prevData) => ({
            ...prevData,
            budget_hours: '',
            remaining_hrs: ''
         }));
      }


      
      timesheetService.getremaining_hrs({ clientid, subclientid,date }).then((response) => {
         let budget_hours = response.data.budget_hours;
         let remaining_hours = response.data.remaining_hours;

         if (ftype == 'add') {
            tmaddsetFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         } else {
            seteditFormData((prevData) => ({
               ...prevData,
               budget_hours: budget_hours,
               remaining_hrs: remaining_hours
            }));
         }
         setremainhrsloaded(true);
         setreminloader(true);
      }).catch((error) => {
         console.log(error);
         setremainhrsloaded(true);
      })
   }


   const validateForm = () => {
      let valid = true;
      const newErrors = {};

      if (!tmaddformData.client.trim()) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (!tmaddformData.subclient.trim()) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }

      if (!tmaddformData.Minutes.trim()) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }

      if (!tmaddformData.Task.trim()) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      if (!tmaddformData.WorkFrom.trim()) {
         newErrors.WorkFrom = 'Work From is required';
         valid = false;
      }

      //  if (!tmaddformData.date.trim()) {
      //    newErrors.date = 'Date is required';
      //    valid = false;
      //  }

      if (!tmaddformData.Remarks.trim()) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      setErrors(newErrors);
      return valid;
   };

   const tmaddhandleSubmit = (e) => {
      e.preventDefault();
      console.log(tmaddformData);
      if (!validateForm()) {
         return
      }
      addtimesheet({ formdata__: tmaddformData });
      // Now you can perform any further actions with the form data
   };


   function addtimesheet({ formdata__ }) {
      let date = formData.fromdate;
      let formateddate = formatterhelper.dateformatter({ date: date });

      formdata__.date = formateddate
      formdata__.taskid = formdata__.Task;
      formdata__.userid = formData.employee;
      formdata__.hours = formdata__.Minutes;
      // console.log(formateddate);
      // console.log(formdata__);
      // return;
      let formdata_ = JSON.stringify(formdata__);
      timesheetService.newappaddtimesheet({ formdata: formdata_ }).then((response) => {
         console.log(response);
         if (response.status == 200) {
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet added successfully`, life: 3000 });
            selusrtms(objdata_);
            settoggleaddform(false);
            tmaddsetFormData({
               client: '',
               subclient: '',
               BilledMinutes: '',
               Count: '',
               Minutes: '',
               Remarks: '',
               Task: '',
               WorkFrom: 'office',
               budget_hours: '',
               date: '0',
               querycount: '',
               remaining_hrs: '',
            });
            // gettimesheetlists({userid:selecteduser});
            // let member = userdata.id;
            // getTimesheets({ selectedmonth: selectedmonth, selectedmember: member }); 
         } else {
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `${response.data.data}`, life: 3000 });
         }

      }).catch((error) => {
         toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet added successfully!`, life: 3000 });
         // settoggleaddform(false);
      });
   }


   const handleChangeedittimesheet = (e) => {
      const { name, value } = e.target;
      seteditFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));

      if (name == 'client') {
         let selected_client = e.target.value;
         seteditFormData((prevData) => ({...prevData,client: selected_client}));
         getallsubclients({ client: selected_client });
         getPercentage(value);
      }

      if (name == 'subclient') {
         console.log(value);
         console.log("subclient");

         const filling_date = formatterhelper.dateformatter({ date: formData.fromdate });
         
         getremaining_hrs({ clientid: editformData.client, subclientid: value, ftype: 'edit',date:filling_date });

        
         let subclientobj = subclients[e.target.selectedIndex - 1];
         seteditFormData((prevData) => ({
            ...prevData,
            subclientid:subclientobj.id 
         }));
      }

      if(name == 'BilledMinutes'){
         // console.log(value);
         let percent = calculatepercent(value,percentage);
         setPercentval(percent);
      }
   };

   const validateeditForm = () => {
      let valid = true;
      const newErrors = {};

      if (editformData.client == '' || editformData.client == undefined) {
         newErrors.client = 'Client is required';
         valid = false;
      }

      if (editformData.subclient == '' || editformData.subclient == undefined) {
         newErrors.subclient = 'SubClient is required';
         valid = false;
      }

      if (editformData.Minutes == '' || editformData.Minutes == undefined) {
         newErrors.Minutes = 'Actual hours is required';
         valid = false;
      }

      if (editformData.Task == '' || editformData.Task == undefined) {
         newErrors.Task = 'Task is required';
         valid = false;
      }

      if (editformData.WorkFrom == '' || editformData.WorkFrom == undefined) {
         newErrors.WorkFrom = 'Work From is required';
         valid = false;
      }

      if (editformData.Remarks == '' || editformData.Remarks == undefined) {
         newErrors.Remarks = 'Remarks is required';
         valid = false;
      }

      setErrors(newErrors);
      return valid;
   };

   const handleSubmitedittimesheet = (e) => {
      e.preventDefault();
      console.log('form data2');
      console.log(editformData);
      if(!validateeditForm()){
          return false;
      }

      let jsondata = JSON.stringify(editformData);
      timesheetService.updateapptimesheet2({formdata:jsondata}).then((response) => {
         console.log(response);
         if(response.status == 200){
            toast.current.show({ severity: 'success', summary: "Timesheet", detail: `Timesheet updated successfully`, life: 3000 });
            settoggle(false);   
            selusrtms(objdata_);
         }else{
            toast.current.show({ severity: 'error', summary: "Timesheet", detail: `${response.data.data}`, life: 3000 }); 
         }
      }).catch((error) => {
         console.log(error);
         toast.current.show({ severity: 'error', summary: "Timesheet", detail: `Timesheet not updated`, life: 3000 });
      });
   };

   function _getallclient() {
      let emparr = [];
      timesheetService.getallclient().then((response) => {
         // setClients(response.data.data);
         response.data.data.forEach((value, index) => {
            if (value.client != '') {
               emparr.push((<option key={index} value={value.client}>{value.client}</option>));
            }

         });
         setClientscomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   function getallsubclients({ client }) {
      let emparr = [];
      setSubclientloader((<Smallloader />));
      return timesheetService.getallsubclienttemp({ client: client }).then((response) => {
         response.data.data.forEach((value, index) => {
            emparr.push((<option key={index} id={value.subclientid} value={value.subclient}>{value.subclient}</option>));
         });

         setsubClientscomp(emparr);
         setsubClients(response.data.data);
         setSubclientloader((<></>));
         return response;
      }).catch((error) => {
         console.log(error);
         setSubclientloader((<></>));
      });
   }
   function getuserslist() {
      let emparr = [];
      timesheetuserService.getuserlistbyapprover().then((response) => {
         console.log(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push(<option value={value.id}>{value.name}</option>);
         });
         setempcomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   function _gettasks() {
      let emparr = [];
      timesheetService.gettasks().then((response) => {
         console.log(response.data.data);
         console.log('response get tasks');
         response.data.data.forEach((value, index) => {
            //    console.log(value); 
            //    console.log('response get tasks'); 
            emparr.push((<option value={value.id}>{value.name}</option>));
         });
         settaskscomp(emparr);

      }).catch((error) => {
         console.log(error);
      });
   }

   function getteammembers() {
      let emparr = [];
      let member = userdata.id;
      timesheetService.getteammembers({ managerid: member }).then((response) => {
         console.log(response.data.data);
         response.data.data.forEach((value, index) => {
            emparr.push(<option value={value.id}>{value.name}</option>);
         });
         setempcomp(emparr);
      }).catch((error) => {
         console.log(error);
      });
   }

   const reject = () => {
      toast.current.show({ severity: 'warn', summary: 'Timesheet', detail: 'Canceled', life: 3000 });
    }

   function deletetm(value){

      confirmDialog({
         message: 'Are you sure you want to proceed?',
         header: 'Confirmation',
         icon: 'pi pi-exclamation-triangle',
         defaultFocus: 'accept',
         accept: () => {
            timesheetService.deletetm(value.obj.id).then((response)=>{
               if(response.status == 200){
                  toast.current.show({ severity: 'success', summary: "Timesheet Deletion", detail: `Timesheet deleted successfully`, life: 3000 }); 
                  selusrtms(objdata_);
               }else{
                  toast.current.show({ severity: 'error', summary: "Timesheet Deletion", detail: `Not deleted`, life: 3000 }); 
               }  
            }).catch((error)=>{
               toast.current.show({ severity: 'error', summary: "Timesheet Deletion", detail: `Error`, life: 3000 }); 
            });
         },
        //  accept,
         reject
     });
      // console.log(value.obj.id);
     
   }

   function selusrtms(obj) {
      let emparr = [];
      setloading(false);
      setDatastate(false);
      timesheetService.selusrtms({ obj: obj }).then((response) => {
        if(response.status == 200){
            console.log(response.data.data);
            console.log("response data");
            setTempdata(response.data.data);   
            response.data.data.forEach((value, index) => {
               // console.log(value); 
               emparr.push((
                  <tr>
                     <td scope="col">{value.id}</td>
                     <td scope="col">{value.date}</td>
                     <td scope="col">{value.client}</td>
                     <td scope="col">{value.subclient}</td>
                     <td scope="col">{value.taskname}</td>
                     <td scope="col">{value.hours}</td>
                     <td scope="col">{value.billedhours}</td>
                     <td scope="col">{value.count}</td>
                     <td scope="col">{value.querycount}</td>
                     <td scope="col"><div style={{width:'200px'}}>{value.remarks}</div></td>
                     <td scope="col">{value.status == 'Verified' ? (<FaCheck />) : (<><FaEdit className='edit-btn-style custom-cursor-style' onClick={() => openToggle({ obj: value })} /> &nbsp; &nbsp; 
                     <FaTrash className='error custom-cursor-style'  onClick={() => deletetm({ obj: value })}/> </> )}</td>
                  </tr>));
            });
   
            setDatacomp(emparr);
            setloading(true);
            setDatastate(true);
         }else{
            setTempdata([]); 
            setDatacomp([]);
            setloading(true);
            setDatastate(true);
         }
         
      }).catch((error) => {
         console.log(error);
         setTempdata([]);
         setDatacomp([]);
         setloading(true);
         setDatastate(true);
      });
   }
   
   

   useEffect(() => {
      // Whenever selectedDate changes, update prevDate
      console.log("from date ");   
      console.log(formData.fromdate);
      setFormData((prevData)=>{
         return{
             ...prevData,
             from_date:formData.fromdate
         }
      });
    }, [addtimesheettoggle]);

    

   function openToggle({ obj }) {
      // console.log("open toggle data");
      try {
         // obj.Task = '';
         obj.Task = obj.taskid;
         obj.Minutes = obj.hours;
         obj.BilledMinutes = obj.billedhours;
         obj.Remarks = obj.remarks;
         obj.Count = obj.count;

         
         console.log("oject data");
         console.log(obj);

         // console.log("object data edit");
         // console.log(obj);
        
         getPercentage(obj.client,{value:obj.BilledMinutes}); 
         
         let objdata = getallsubclients({ client: obj.client });
         // console.log("object data");
         // console.log(objdata);
         seteditFormData({ ...obj, WorkFrom: obj.workfrom || '' });
         settoggle(true);

         objdata.then((response) => {
            if (response == undefined || response == '') {
               return;
            }
            console.log(response.data.data);
            // return;
            let objselected = {};
            response.data.data.forEach((value, index) => {
               if (obj.subclient == value.subclient) {
                  objselected = value;
               }
            });

            // seteditFormData((prevData)=>({
            //    ...prevData,
            //    date:obj.date
            // })) 

            const filling_date = formatterhelper.dateformatter({ date: obj.date });
            getremaining_hrs({ clientid: obj.client, subclientid: objselected.subclient, ftype: 'edit',date:filling_date });
         });
      } catch (error) {
         console.log("error");
         console.log(error);
      }
   }


   const remainconditioncomp = (type) => {
      if (type == 'add') {

         let obj = {
            'message': (<></>),
            'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)}  step="any"/>),
            'budgethourscomp': (<></>)
         };

         
         if (tmaddformData != undefined) {


            if (tmaddformData.remaining_hrs === 0) {
               obj.message = (<Message className='custom-width-style' severity="info" text="Note : Remaining hours are not available, Chargeable Minutes are not permitted!" />);
               obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
               obj.budgethourscomp = (<></>);
            }
            else if (tmaddformData.budget_hours == '' || tmaddformData.remaining_hrs == '') {
               obj.message = (<Message className='custom-width-style' severity="error" text="Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!" />);
               obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
               obj.budgethourscomp = (<></>);
               obj.remainhourscomp = (<></>);

            } else if (tmaddformData.budget_hours > 0 || tmaddformData.remaining_hrs > 0) {
               obj.budgethourscomp = (<div className='col-md-3'>
                  <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                  <input type='number' disabled="true" value={tmaddformData.budget_hours} name='budget_hours' class="form-control" onChange={(e) => tmaddChange(e)} />
               </div>);

               obj.remainhourscomp = (<div className='col-md-3'>
                  <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                  <input type='number' disabled="true" value={tmaddformData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => tmaddChange(e)} />
               </div>);
            }


            if(userdata.project == 'Bookkeeping'){
               let obj = {
                  'message': (<></>),
                  'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
                  'budgethourscomp': (<></>)
               }; 
               return obj;   
            }
            return obj;
         }
      }

   }


   const remainconditioncompedit = () => {
      let obj = {
         'message': (<></>),
         'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} step="1" oninvalid="this.setCustomValidity('Please enter a whole number')" oninput="this.setCustomValidity('')" />),
         'budgethourscomp': (<></>)
      };
      if (editformData.remaining_hrs === 0) {
         obj.message = (<Message className='custom-width-style' severity="info" text="Note : Remaining hours are not available, Chargeable Minutes are not permitted!" />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
         obj.budgethourscomp = (<></>);
      }
      else if (editformData.budget_hours == '' || editformData.remaining_hrs == '') {
         obj.message = (<Message className='custom-width-style' severity="error" text="Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!" />);
         obj.component = (<input type='number' disabled="true" name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />);
         obj.budgethourscomp = (<></>);
         obj.remainhourscomp = (<></>);

      } else if (editformData.budget_hours > 0 || editformData.remaining_hrs > 0) {
         obj.budgethourscomp = (<div className='col-md-3'>
            <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={editformData.budget_hours} name='budget_hours' class="form-control" onChange={(e) => tmaddChange(e)} />
         </div>);

         obj.remainhourscomp = (<div className='col-md-3'>
            <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
            <input type='number' disabled="true" value={editformData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => tmaddChange(e)} />
         </div>);
      }

      if(userdata.project == 'Bookkeeping'){
         let obj = {
            'message': (<></>),
            'component': (<input type='number' name='BilledMinutes' class="form-control" onChange={(e) => tmaddChange(e)} />),
            'budgethourscomp': (<></>)
         }; 
         return obj;   
      }
      return obj;

   }

   function counterfunction(){
      let totalmin = 0;
      let count = 0;

      console.log('counter function changed');
      
      if(tempdata != undefined && tempdata.length > 0){
         console.log("counter function data lits");
         // console.log(tmslists,"timesshet lists");
         tempdata.forEach((values)=>{
            totalmin = (typeof values.hours === 'number' ? values.hours : 0) + totalmin;
            count = (typeof values.count === 'number' ? values.count : 0)  + count;
         });

         // settimesheetliststemp(data);
         if(tempdata.length <= 0 ){
            setminutescount({minutes:0,count:0});
         }else{
            setminutescount({minutes:totalmin,count:count});
         }
      }
    }

   function fillingforcomp() {
      const today = new Date();
      const dayName = today.toLocaleDateString('en-US', { weekday: 'long' });
      let fillingobj = { 'daystr': 'Yesturday', 'dayno': '1' };

      if (dayName == 'Sunday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '2';
      }
      else if (dayName == 'Monday') {
         fillingobj.daystr = 'Friday';
         fillingobj.dayno = '3';
      } else {
         fillingobj.daystr = 'Yesturday';
         fillingobj.dayno = '1';
      }

      return fillingobj;
   }

   function querycountcomp(){
      let comp = {'add':(<></>),'edit':(<></>)};
      if(userdata.project == 'Bookkeeping'){
          comp.add = (<div className='col-md-3'>
          <label>Query Count</label>
          <input type='text' name='querycount' class="form-control" onChange={(e) => handleChange(e)}/>  
          </div>);

          comp.edit = (<div className='col-md-3'>
          <label>Query Count</label>
          <input type='text' name='querycount' value={editformData.querycount} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>  
          </div>);
      }
      return comp;
   }

   function displaypercentage(percent) {
      return (
         userdata.project_name == 'Year End' ?
            (<div className='col-md-6'>
               <br/> 
               <label>QA Percentage</label>
               <br />
               <br />
               <b>Percent : {percentage} %</b>
               &nbsp;
               <span>| Value : {percent}</span>   
            </div>) : '');
   }


   useEffect(()=>{
           if((filteredobj.userid != undefined && filteredobj.userid != '')){
               if((filteredobj.date != undefined && filteredobj.date != '')){
                  //  gettimesheetapproval(filteredobj);  
                   getTimesheets({selectedmonth:filteredobj.date,selectedmember:filteredobj.userid});
               }
                       
           } 
       },[filteredobj]);


    function getTimesheets({ selectedmonth, selectedmember }) {
              try {
                 let member = selectedmember;
                 let onceposition = 0;
                 setloading(false);
                 timesheetService.gettimesheet({ month: selectedmonth, member: member }).then((response) => {
                    console.log("response data");
                    // console.log(response.status);
                    if (response.status == 200) {
                       //    console.log(response.data.data);   
                          setMonthsdata(response.data.data);
                    } else {
                          setMonthsdata([]);     
                    }
                 }).catch((error) => {
                       setMonthsdata([]);
                 });
              } catch (error) {
                 console.log(error);
              }
        
           }


    function displaymonthsdata(){
            let arr = [];
            monthsdata.forEach((value,index)=>{

                // saturday sunday    
                if(value.status == 3){
                     arr.push(<td className='dayssat-style'><tr>{value.total_hours}</tr><tr>{value.Date}</tr></td>);   
                }

                // approved 
                if(value.status == 0){
                     arr.push(<td className='approved-style'><tr>{value.total_hours}</tr><tr>{value.Date}</tr></td>);   
                } 
                // filled    
                if(value.status == 1){
                     arr.push(<td className='filled-style'><tr>{value.total_hours}</tr><tr>{value.Date}</tr></td>);   
                } 
                  
                // not filled
                if(value.status == 2){
                     arr.push(<td><tr>{value.total_hours}</tr><tr>{value.Date}</tr></td>);   
                } 

            })

            return (<table style={{width:'100%'}}><tr>
                  {arr}
                </tr></table>);
        }

   return (
      <>
         <Toast ref={toast} />
         <ConfirmDialog />
         <div className="invisible-divider-sm"></div>
         <h6>Timesheet Admin</h6>
         <div className='card card-custom-style card-style-padding'>
            <form onSubmit={handleSubmit}>
               <div className='row'>
                  <div className="col-md-2">
                     <label className='pull-left'><Mandate />Select date</label>
                     <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                  </div>
                  <div className="col-md-2">
                     <label className='pull-left'><Mandate />Select User</label>
                     <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                        <option value="">Select</option>
                        {empcomp}
                     </select>
                  </div>
                  <div className="col-md-3 col-sm-12">
                     <div className='button-wrapper-style'>
                        {formData.employee != '' && formData.fromdate != '' ? (<Button type='submit' stype="button" onClick={() => settoggleaddform(true)} label="Add Timesheet" severity="success" rounded className='custom-btn-style' />) : (<></>)}

                     </div>

                  </div>

                  <div className='col-md-5' style={{aligncontent: 'end'}}>
                        <div className='pagination-style'>Total Minutes : {minutestcount.minutes} | Count : {minutestcount.count}</div>
                    </div>
               </div>
            </form>
         </div>
         <div className="invisible-divider-sm"></div>
         <div className='card card-custom-style card-style-padding'>
            <div className='row'>
               <div className='col-md-6'></div>
               <div className='pagination col-md-6'>
                  {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
               </div>
            </div>

            <Dialog header="Add Timesheet" visible={toggleaddform} style={{ width: '60vw' }} onHide={() => { settoggleaddform(false) }}>
               <form onSubmit={tmaddhandleSubmit}>
                  <div className='col-md-12'>
                     <div className='row'>
                        <div className='col-md-12'>
                           {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncomp('add').message)}
                           {/* {remainconditioncomp().message} */}
                           <br />
                           <br />
                           {/* <h2>Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!</h2> */}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate />Select Client</label>
                           <select className='custom-dropdown-style' required name="client" class="form-control" onChange={(e) => tmaddChange(e)}>
                              <option value="">select</option>
                              {clientscomp}
                           </select>
                           {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate />Select SubClient</label><span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' required name="subclient" onChange={(e) => tmaddChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subclientscomp}
                           </select>
                           {errors.subclient && <span className='error'>{errors.subclient}</span>}

                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-3'>
                           <label><Mandate />Task</label>
                           <select className='custom-dropdown-style' required name="Task" onChange={(e) => tmaddChange(e)} class="form-control">
                              <option value="">Select</option>
                              {subtaskscomp}
                           </select>
                           {errors.Task && <span className='error'>{errors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate />Work From</label>
                           <select className='custom-dropdown-style' required value={tmaddformData.WorkFrom} name="WorkFrom" onChange={(e) => tmaddChange(e)} class="form-control">
                              <option value="">Select</option>
                              <option value="home">Home</option>
                              <option value="office">Office</option>
                           </select>
                           {errors.WorkFrom && <span className='error'>{errors.WorkFrom}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate />Minutes</label>
                           <input type='number' name="Minutes" required class="form-control" onChange={(e) => tmaddChange(e)} step="any"/>
                           {errors.Minutes && <span className='error'>{errors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Chargeable Minutes</label>
                           {remainconditioncomp('add').component}
                           {/* <input type='number' name='BilledMinutes' class="form-control" onChange={(e) => handleChange(e)}/>   */}
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        {remainconditioncomp('add').budgethourscomp}
                        {/* <div className='col-md-3'>
                        <label>Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>  
                        <input type='number' disabled="true" value={formData.budget_hours}  name='budget_hours' class="form-control" onChange={(e) => handleChange(e)}/>
                     </div> */}
                        {remainconditioncomp('add').remainhourscomp}
                        {/* <div className='col-md-3'>
                        <label>Remaining Budget Hours <span>{!remainhrsloaded ? loader.Smallloader() : (<></>)}</span></label>
                        <input type='number' disabled="true" value={formData.remaining_hrs} name='remaining_hrs' class="form-control" onChange={(e) => handleChange(e)}/>  
                     </div> */}
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' class="form-control" onChange={(e) => tmaddChange(e)} />
                        </div>

                        {/* <div className='col-md-3'>
                     <label><Mandate/>Filling For</label>
                     <select className='custom-dropdown-style' value={formData.date} name="date" onChange={(e) => tmaddChange(e)} class="form-control">
                           <option value="0">Today</option>
                           <option value={fillingforcomp().dayno}>{fillingforcomp().daystr}</option>
                        </select> 
                        {errors.date && <span className='error'>{errors.date}</span>} 
                     </div> */}

                        <div className='col-md-6'>
                           <label><Mandate />Remarks</label>
                           <br />
                           

                           {userdata?.dept != 'IT Support (1009)' ? 
                           ( <textarea name='Remarks' required onChange={(e) => tmaddChange(e)} class="form-control"></textarea>) : 
                           (<input type="text" name='Remarks' required onChange={(e) => tmaddChange(e)} class="form-control"/>)}
                           {/* <input type='text' name='Remarks' onChange={(e) => handleChange(e)} class="form-control"/>   */}
                           {errors.Remarks && <span className='error'>{errors.Remarks}</span>}
                        </div>

                        {displaypercentage(percentval)} 

                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" onClick={() => settoggleaddform(false)} stype="button" label="Close" severity="danger" rounded />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>
           

            <Dialog header="Edit Timesheet" visible={addtimesheettoggle} style={{ width: '60vw' }} onHide={() => settoggle(false)}>
               <form onSubmit={handleSubmitedittimesheet}>
                  <div className='col-md-12'>
                     <div className='row'>
                        <div className='col-md-12'>
                           {!remainloaded ? (<span className='pull-right'>{Smallloader()}</span>) : (remainconditioncompedit().message)}
                           {/* {remainconditioncomp().message} */}
                           <br />
                           <br />
                           {/* <h2>Note : Subclient Budget hours are not available, Chargeable Minutes are not permitted!</h2> */}
                        </div>
                     </div>
                     <div className='row'>
                        <div className='col-md-6'>
                           <label><Mandate /> Select Client </label>
                           <select className='custom-dropdown-style' required name="client" value={editformData.client} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">select client</option>
                              {clientscomp}
                           </select>
                           {errors.client && <span className='error'>{errors.client}</span>}
                        </div>
                        <div className='col-md-6'>
                           <label><Mandate /> Select SubClient </label>
                           <span>{subclientLoader}</span>
                           <select className='custom-dropdown-style' required name="subclient" value={editformData.subclient} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">select subclient</option>
                              {subclientscomp}
                           </select>
                           {errors.subclient && <span className='error'>{errors.subclient}</span>}
                        </div>
                     </div>
                     <br />

                     <div className='row'>
                        <div className='col-md-3'>
                           <label><Mandate /> Task</label>
                           <select className='custom-dropdown-style' required name="Task" value={editformData.Task} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}>
                              <option value="">Select Task</option>
                              {subtaskscomp}
                           </select>
                           {errors.Task && <span className='error'>{errors.Task}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate /> Work From</label>
                           <select className='custom-dropdown-style' required value={editformData.WorkFrom} name="WorkFrom" onChange={(e) => handleChangeedittimesheet(e)} class="form-control">
                              <option value="">Select</option>
                              <option value="office">Office</option>
                              <option value="home">Home</option>
                           </select>
                           {errors.WorkFrom && <span className='error'>{errors.WorkFrom}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label><Mandate /> Minutes</label>
                           <input type='number' name='Minutes' required value={editformData.Minutes} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} step="any"/>
                           {errors.Minutes && <span className='error'>{errors.Minutes}</span>}
                        </div>
                        <div className='col-md-3'>
                           <label>Billed minutes</label>
                           <input type='number' name='BilledMinutes' value={editformData.BilledMinutes} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} step="any"/>
                        </div>
                     </div>
                     <br />
                     <div className='row'>
                        {remainconditioncompedit().budgethourscomp}
                        {remainconditioncompedit().remainhourscomp}
                        {/* <div className='col-md-3'>
                        <label>Budget Hours</label>  
                        <input type='number' name='budget_hours' value={editformData.budget_hours} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>
                     </div>
                     <div className='col-md-3'>
                        <label>Remaining Budget Hours</label>
                        <input type='number' name='remaining_hrs' value={editformData.remaining_hrs} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>  
                     </div> */}
                        <div className='col-md-3'>
                           <label>Count</label>
                           <input type='text' name='Count' value={editformData.Count} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />
                        </div>

                        {querycountcomp().edit}

                        {/* <div className='col-md-3'>
                     <label>Filling For</label>
                     <select className='custom-dropdown-style' name='fillingfor' value={editformData.fillingfor} class="form-control" onChange={(e) => handleChangetimesheet(e)}>
                           <option value="0">Today</option>
                           <option value="1">Yesturday</option>
                        </select> 
                     </div> */}

                        <div className='col-md-6'>
                           <label><Mandate /> Remarks</label>
                           <br />
                           {userdata?.dept != 'IT Support (1009)' ? 
                           ( <textarea type='text' required name='Remarks' value={editformData.Remarks} class="form-control" onChange={(e) => handleChangeedittimesheet(e)} />) : 
                           (<input type="text" name='Remarks' value={editformData.Remarks} class="form-control" onChange={(e) => handleChangeedittimesheet(e)}/>)}

                           
                           {errors.Remarks && <span className='error'>{errors.Remarks}</span>}
                        </div>
                        {displaypercentage(percentval)} 

                     </div>
                     <br />

                     <div className='row'>
                        <div>
                           <div className='pull-right'>
                              <span>
                                 <Button type="submit" label="Save" severity="success" rounded />
                              </span>

                              <span>
                                 <Button type="button" label="Close" severity="danger" rounded onClick={() => settoggle(false)} />
                              </span>
                           </div>
                        </div>
                     </div>
                  </div>
               </form>
            </Dialog>

            <div className='row'>
               <div className='col-md-12'>
                        {displaymonthsdata()}
                       
                        <br/>
                    </div> 
               {!isloaded ? loader.Loadermd() : dataavail ?
                  (<table class="table table-bordered">
                     <thead>
                        <tr>
                           <th scope="col">Id</th>
                           <th scope="col">Date</th>
                           <th scope="col">Client name</th>
                           <th scope="col">Subclient name</th>
                           <th scope="col">Task</th>
                           <th scope="col">Minutes</th>
                           <th scope="col">Billing Minutes</th>
                           <th scope="col">Count</th>
                           <th scope="col">Query Count</th>
                           <th scope="col">Remarks</th>
                           <th scope="col">Action</th>
                        </tr>
                     </thead>
                     <tbody>
                        {datacomp}
                     </tbody>
                  </table>) : (<p>No data Found</p>)}
            </div>
            <br />

         </div>

         <div className="invisible-divider-sm"></div>
         {/* <div className="row">
                <h1>table</h1>
            </div> */}
      </>
   );
}

export default Timesheetadmin;

